import { useCubeContext } from 'Cube/communication/internal/cube.domain.context'

import {
  PUBLISH_BODY_TEST_IDS,
  PUBLISH_MODAL_COPY
} from './PublishQuoteModalV2/PublishQuoteModalV2.constants'

const PUBLISH_BODY_COPY = {
  anyoneWithTheLink: {
    publishQuote: PUBLISH_MODAL_COPY.publishQuote.body,
    publishChanges: PUBLISH_MODAL_COPY.publishChanges.body,
    'data-testid': PUBLISH_BODY_TEST_IDS.anyoneWithTheLink
  },
  authRequired: {
    publishQuote: PUBLISH_MODAL_COPY.publishQuote.bodyAuthRequired,
    publishChanges: PUBLISH_MODAL_COPY.publishChanges.bodyAuthRequired,
    'data-testid': PUBLISH_BODY_TEST_IDS.authRequired
  }
} as const

export type PublishBodyCopy = {
  publishQuote: string
  publishChanges: string
  'data-testid': string
}

/**
 * The sentence each publish modal opens with, which has to match who will
 * actually be able to open the quote. With portal authentication on, recipients
 * sign in before they see anything, so telling someone the link alone is enough
 * would be wrong.
 *
 * The test id names which of the two is showing, so a test asserts the case
 * instead of matching the sentence word for word.
 *
 * Both sets are module constants, so the object a modal gets back keeps the
 * same identity between renders and can sit in a `useMemo` dependency list.
 */
export const usePublishBodyCopy = (): PublishBodyCopy => {
  const ctx = useCubeContext()

  return ctx.queries.rawData.data.quote.isCustomerPortalAuthRequired
    ? PUBLISH_BODY_COPY.authRequired
    : PUBLISH_BODY_COPY.anyoneWithTheLink
}
